import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const archivedCarsSellerApi = createApi({
    reducerPath: "archivedCarsSellerApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllArchivedCarsSeller: builder.query({
            query: () => ({
                url: "/Car/all-archived-cars-seller",
                method: "GET",
            }),
        }),
    }),
});

export const { useGetAllArchivedCarsSellerQuery } = archivedCarsSellerApi;
